<script setup>
import { inject, onMounted, onUpdated } from "vue";
import feather from "feather-icons";
import { Icon } from "@iconify/vue";
import { footerLinks } from "@/data/links";

const year = new Date().getFullYear();
const themeState = inject("themeState");

const getHoverBorderColor = (link) => {
  return themeState?.theme === "dark" && link.darkBorderColor
    ? link.darkBorderColor
    : link.borderColor;
};

const getHoverIconColor = (link) => {
  if (themeState?.theme === "dark") {
    return link.darkColor || "#ffffff";
  }

  return link.color;
};

onMounted(() => {
  feather.replace();
});

onUpdated(() => {
  feather.replace();
});
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-5 text-center">
    <div class="flex items-center justify-center gap-3">
      <a
        v-for="link in footerLinks"
        :key="link.id"
        :href="link.href"
        target="_blank"
        rel="noopener noreferrer"
        :aria-label="link.title"
        class="footer-link flex h-11 w-11 items-center justify-center rounded-full border transition duration-300 hover:-translate-y-1"
        :style="{
          '--footer-icon-color': link.color,
          '--footer-hover-color': getHoverIconColor(link),
          '--footer-hover-border': getHoverBorderColor(link),
          '--footer-hover-bg': link.background,
        }">
        <i
          v-if="link.iconType === 'feather'"
          :data-feather="link.icon"
          class="footer-icon h-5 w-5"></i>
        <Icon
          v-else
          :icon="link.icon"
          class="footer-icon h-5 w-5" />
      </a>
    </div>

    <div
      class="font-general-regular text-lg text-ternary-dark dark:text-ternary-light">
      © {{ year }} Arif Islam. All rights reserved.
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-link {
  border-color: rgb(203 213 225);
  background-color: #fff;
}

.footer-icon {
  color: var(--footer-icon-color);
  transition: transform 0.2s ease;
}

.footer-link:hover {
  border-color: var(--footer-hover-border);
  background-color: var(--footer-hover-bg);
}

.footer-link:hover .footer-icon {
  color: var(--footer-hover-color);
  transform: scale(1.08);
}
</style>
